<template>
  <Recommendations
    v-if="productResponse && !errorRecommendations"
    class="mt-56"
    data-id="reco-section"
    :product="productResponse"
    :selected-offer
    :with-ranking
    @bundle-add-to-cart="onBundleAddToCart"
    @recommendations-error="onRecommendationsError"
    @recommendations-loaded="onRecommendationsLoaded"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { Product } from '@backmarket/nuxt-layer-recommendation/models/product'

import { useFetchPickers } from '~/scopes/product-core//composables/useFetch/useFetchPickers/useFetchPickers'
import Recommendations from '~/scopes/product-core/components/presentationals/Recommendations/Recommendations.vue'
import { useAddToCartOverlay } from '~/scopes/product-core/composables/stores/useAddToCartOverlay/useAddToCartOverlay'
import { useAdditionalProduct } from '~/scopes/product-core/composables/stores/useAdditionalProduct/useAdditionalProduct'
import { useOutOfStockAlternative } from '~/scopes/product-core/composables/stores/useOutOfStockAlternative/useOutOfStockAlternative'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { withRanking } = defineProps<{
  withRanking?: boolean
}>()

const { data: productResponse } = useFetchProduct()
const { selectedOffer } = useFetchPickers()

const { openAddToCartOverlay } = useAddToCartOverlay()
const { setAdditionalProduct } = useAdditionalProduct()
const {
  setOutOfStockAlternative,
  clearOutOfStockAlternative,
  setOutOfStockAlternativeLoading,
} = useOutOfStockAlternative()

const errorRecommendations = ref(false)

function onRecommendationsError() {
  errorRecommendations.value = true
  clearOutOfStockAlternative()
  setOutOfStockAlternativeLoading(false)
}

function onRecommendationsLoaded(products: Array<Product>) {
  setOutOfStockAlternative(products[0])
  setOutOfStockAlternativeLoading(false)
}

function onBundleAddToCart(_listings: Array<string>, product: Product | null) {
  setAdditionalProduct(product)
  openAddToCartOverlay()
}
</script>
